import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map, Observable } from 'rxjs';
import { LendioResponse } from '../interfaces/lendio-response';
import { Message } from '../interfaces/message.model';
import { MessageReply } from '../interfaces/message-reply.model';

@Injectable({ providedIn: 'root' })
export class MessagesService {
  private apiUrl = `${environment.apiUrl}/partner-portal`;

  constructor(private http: HttpClient) {}

  public getMessages(dealId: number): Observable<Message[]> {
    return this.http
      .get<LendioResponse<Message[]>>(`${this.apiUrl}/deals/${dealId}/messages`)
      .pipe(map((response) => response.data ?? []));
  }

  public createNewMessage(dealId: number, description: string): Observable<Message | null> {
    return this.http
      .post<LendioResponse<Message>>(`${this.apiUrl}/deals/${dealId}/messages`,
        {
          description,
        })
      .pipe(map((response) => response.data ?? null));
  }

  public createNewReply(
    dealId: number,
    taskId: number,
    description: string
  ): Observable<MessageReply | null> {
    return this.http.post<LendioResponse<MessageReply>>(`${this.apiUrl}/deals/${dealId}/messages/${taskId}/reply`,
      { description }
    ).pipe(map((response) => response.data ?? null));
  }
}
